package app.bloomey.web.modules.library

import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.data.models.Category
import app.bloomey.web.core.data.models.CategoryUpdateRequest
import app.bloomey.web.core.data.models.PageResponse
import app.bloomey.web.core.data.models.Video
import app.bloomey.web.utils.ApiError
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

class LibraryRepository {
    private val api = LibraryApi()

    fun getLibraries(page: Int, size: Int, query: String): Flow<UiState<PageResponse<List<Category>>>> = flow {
        try {
            emit(UiState.Loading)
            val response = api.getLibraries(page, size, query)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e)))
        }
    }

    fun getCategoryVideos(id: String, page: Int, size: Int) = flow<UiState<PageResponse<List<Video>>>> {
        try {
            emit(UiState.Loading)
            val response = api.getCategoryVideos(id, page, size)
            emit(UiState.Success(response))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e)))
        }
    }

    fun deleteLibrary(id: String) = flow<UiState<Boolean>> {
        try {
            emit(UiState.Loading)
            val response = api.deleteLibrary(id)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e)))
        }
    }

    fun updateLibrary(id: String, request: CategoryUpdateRequest) = flow<UiState<Boolean>> {
        try {
            emit(UiState.Loading)
            val response = api.updateLibrary(id, request)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            console.error(e)
            emit(UiState.Error(ApiError.parseMessage(e)))
        }
    }
}